// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-tjcx-hjblxqcx-index-main_right_content-1P3BN","table":"components-tjcx-hjblxqcx-index-table-jxznE"};


//////////////////
// WEBPACK FOOTER
// ./components/tjcx/hjblxqcx/index.css
// module id = 2305
// module chunks = 0